import { useState } from "react";
import {
    Box,
    Container,
    Tab,
    Tabs,
    Typography
} from "@mui/material";

import SimuladorAhorro from "./SimuladorAhorro";
import SimuladorInversion from "./SimuladorInversion";
import SimuladorPrestamo from "./SimuladorPrestamo";
import EnConstruccion from "./EnConstruccion";

const Simuladores = () => {
    const [tab, setTab] = useState(0);

    return (
        <Box
            sx={{
                py: 10,
                backgroundColor: "#f7f7f7",
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    sx={{
                        textAlign: "center",
                        color: "#4e6b4d",
                        fontSize: {
                            xs: "2rem",
                            md: "3rem",
                        },
                        mb: 5,
                    }}
                >
                    Simuladores Financieros
                </Typography>

                <Box
                    sx={{
                        backgroundColor: "#fff",
                        borderRadius: 4,
                        overflow: "hidden",
                        boxShadow:
                            "0 10px 30px rgba(0,0,0,.08)",
                    }}
                >
                    <Tabs
                        value={tab}
                        onChange={(e, value) =>
                            setTab(value)
                        }
                        centered
                        variant="fullWidth"
                        sx={{
                            "& .MuiTabs-indicator": {
                                backgroundColor: "#4e6b4d",
                                height: 4,
                            },
                        }}
                    >
                        <Tab
                            label="AHORRO"
                            sx={{
                                color: "#4e6b4d",
                                "&.Mui-selected": {
                                    color: "#ffd700",
                                    fontWeight: 600,
                                },
                            }}
                        />

                        <Tab
                            label="INVERSIÓN"
                            sx={{
                                color: "#4e6b4d",
                                "&.Mui-selected": {
                                    color: "#ffd700",
                                    fontWeight: 600,
                                },
                            }}
                        />

                        <Tab
                            label="PRÉSTAMOS"
                            sx={{
                                color: "#4e6b4d",
                                "&.Mui-selected": {
                                    color: "#ffd700",
                                    fontWeight: 600,
                                },
                            }}
                        />
                    </Tabs>

                    <Box sx={{ p: 4 }}>
                        {tab === 0 && (
                            <EnConstruccion />
                        )}

                        {tab === 1 && (
                            <EnConstruccion />
                        )}

                        {tab === 2 && (
                            <EnConstruccion />
                        )}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Simuladores;